import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  titleBlue: {
    color: '#1671ED',
    cursor: 'move',
  },
  dialog: {
    maxHeight: '900px',
    minHeight: '68%',
  },
  container: {
    display: 'flex',
    width: '600px',
    maxWidth: '600px',
    height: '100%',
    padding: '35px',
    flexDirection: 'column',
    borderTop: '2px solid #E3E3E3',
    overflowX: 'hidden',
  },
  subcontainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  subjectWrapper: {
    display: 'none',
    marginBottom: '10px',
  },
  selectLabel: {
    fontSize: '18px !important',
  },
  dialogAction: {
    padding: '20px 30px',
  },
  button: {
    width: '120px',
  },
}))
